import React from "react";
import AddButton from "components/ui/Button/AddButton/AddButton";
import { DeleteIconButton } from "components/ui/Button/IconButton/IconButton";
import { Checkbox } from "components/ui";
import CustomRulesDropDown from "./CustomRulesDropDown/CustomRulesDropDown";
import { formElementBlocks } from "components/dashboard/KnowledgeBase/FormSetup/BuilderElementsList/data";
import FileAttachment from "./FileAttachment/FileAttachment";
import FormAccessControl from "components/dashboard/KnowledgeBase/Forms/FormAccessControl";
import "./FormBuilderInputHeading.scss";

const FormBuilderInputHeading = ({
    id,
    elementType,
    enableSubTitleText,
    acceptNewInputRule,
    customRules,
    handleSubTextStatusChange,
    handleInputDelete,
    toggleBranchModal,
    handleFileAttachmentChange,
    handleUploadUpdate,
}) => {
    return (
        <div className='formbuilder__input--heading'>
            <div className='row align-items-center'>
                <div className='col-1'></div>
                <div className='col-md-2'>
                    <div className='text--holder'>
                        <h3>{formElementBlocks?.[elementType]?.title}</h3>
                    </div>
                </div>
                <div className='col-md-4 pe-0'>
                    {elementType !== "END_FORM" && (
                        <FormAccessControl action='itemWrite'>
                            <Checkbox
                                name='addSubtitle'
                                label='Enable subtitile instruction'
                                labelClass='text-grey'
                                inputClass='input-check-grey'
                                id='addSubtitle'
                                checked={enableSubTitleText}
                                onChange={(e) =>
                                    handleSubTextStatusChange(
                                        id,
                                        e.target.checked
                                    )
                                }
                            />
                        </FormAccessControl>
                    )}
                </div>
                <div className='col-md-5'>
                    <div className='row formbuilder__heading__actions'>
                        <div className='col-md-7 px-0'>
                            {elementType === "END_FORM" ? (
                                <FormAccessControl action='itemWrite'>
                                    <AddButton
                                        btnText={"Create Collection"}
                                        onClick={() => toggleBranchModal()}
                                    />
                                </FormAccessControl>
                            ) : (
                                <FormAccessControl action='itemWrite'>
                                    <CustomRulesDropDown
                                        id={id}
                                        elementType={elementType}
                                        acceptNewInputRule={acceptNewInputRule}
                                        selectedRules={customRules}
                                    />
                                </FormAccessControl>
                            )}
                        </div>
                        <div className='col-md-2'>
                            <FormAccessControl action='itemWrite'>
                                <FileAttachment
                                    id={id}
                                    handleFileAttachmentChange={
                                        handleFileAttachmentChange
                                    }
                                    handleUploadUpdate={handleUploadUpdate}
                                />
                            </FormAccessControl>
                        </div>
                        <div className='col-md-3'>
                            <FormAccessControl action='delete'>
                                <DeleteIconButton
                                    onClick={() => handleInputDelete(id)}
                                />
                            </FormAccessControl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormBuilderInputHeading;
